<div>
	<app-breadcrumbs></app-breadcrumbs>
</div>

<div>
	@if (!(adminService.selectedUserPool$ | async)?.name) {
		<nz-card>
			<app-user-pool-list></app-user-pool-list>
		</nz-card>
	}

	@if ((adminService.selectedUserPool$ | async)?.name && !(adminService.selectedUser$ | async)?.uuid) {
		<nz-card>
			<nz-tabs>
				<nz-tab nzTitle="Edit Users">
					<app-user-list></app-user-list>
				</nz-tab>

				@if (cognitoService.isEmailUserPool((adminService.selectedUserPool$ | async)?.id)) {
					<nz-tab nzTitle="Generate Users (emails)">
						<app-generate-email-users></app-generate-email-users>
					</nz-tab>
				}

				@if (cognitoService.isUuidUserPool((adminService.selectedUserPool$ | async)?.id)) {
					<nz-tab nzTitle="Generate Users (no emails)">
						<app-generate-uuid-users></app-generate-uuid-users>
					</nz-tab>
				}

			</nz-tabs>
		</nz-card>
	}

	@if ((adminService.selectedUser$ | async)?.uuid) {
		<nz-card>
			<div class="form-container">
				<nz-tabs>
					<nz-tab nzTitle="User">
						@if ((adminService.selectedUser$ | async) !== undefined) {
							<nz-card>
								<app-cognito-user-form
									[cognitoUser]="(adminService.selectedUser$ | async) || undefined"
									(onSubmit)="onCognitoUserFormSubmit$($event)"
								></app-cognito-user-form>
							</nz-card>
						}
					</nz-tab>

					@if (isAdmin()) {
						<nz-tab nzTitle="Logins">
							<app-login-tracking-list [logins]="logins()"></app-login-tracking-list>
						</nz-tab>
					}

					<nz-tab nzTitle="Skill">
						<nz-tabs>
							<nz-tab nzTitle="Level">
								<app-course-selector
									[clientUuids]="selectedUserClientUuids()"
									(onSelectCourse)="selectCourse($event)"
								></app-course-selector>

								@if (selectedCourse()) {
									<app-user-skill-level [course]="selectedCourse()"></app-user-skill-level>
								}
							</nz-tab>

							<nz-tab nzTitle="History">
								<app-user-skill-history></app-user-skill-history>
							</nz-tab>
						</nz-tabs>
					</nz-tab>
				</nz-tabs>
			</div>
		</nz-card>
	}
</div>
